import type { QAQueryOptionDTO } from '@next-space/fe-api-idl';
import { useMemo, type FC } from 'react';
import { useChatTranslation } from '../hooks/use-i18n';
import { findAIModel } from '../../ai-const';
import { getQAQueryOption } from '../hooks/hook';
interface Prop {
  queryOption?: QAQueryOptionDTO;
}
export const AnswerSource: FC<Prop> = (props) => {
  const { t } = useChatTranslation();
  const currentModelText = useMemo(() => {
    return findAIModel(getQAQueryOption(props.queryOption).model).title;
  }, [props.queryOption]);
  if (!props.queryOption) return null;

  return (
    <span className="text-t4 inline-flex items-center text-normal/50">
      <div className="px-1 rounded bg-aside mr-1">
        {t(props.queryOption.networkSearch ? 'chatWebSearch' : 'chatSpace')}
      </div>
      <div className="px-1 rounded bg-aside">{currentModelText}</div>
    </span>
  );
};
